import { type AssetHierarchyItem } from 'horizon/components/Assets/AssetPicker/types';
import { type AtlasGqlAsset } from 'types/atlas-graphql';
import { ASSET_TYPE_BLADE, ASSET_TYPE_SITE, ASSET_TYPE_TURBINE } from 'utils/constants';
import { useFeatures } from 'utils/features';

export function useFilterAssetTypeOptionsForInspectionUploads() {
  const { FLEET_MANAGEMENT } = useFeatures().features;

  return (asset: AtlasGqlAsset, parentAsset?: AssetHierarchyItem): boolean => {
    // filter child option of the site asset picker to not display the blade
    // asset type, disabling the ability to select stored blades
    if (parentAsset?.assetTypeName === ASSET_TYPE_SITE) {
      return asset.assetType?.name !== ASSET_TYPE_BLADE;
    }

    // when the user does not have `FLEET_MANAGEMENT` feature, only allow them
    // to view blade assets when the parent asset is turbine
    if (!FLEET_MANAGEMENT && parentAsset?.assetTypeName === ASSET_TYPE_TURBINE) {
      return asset.assetType?.name === ASSET_TYPE_BLADE;
    }

    return true;
  };
}
